<template>
  <div>
    <page-header
      :title="title"
      :container-class="containerClass"
      :info-text="'Select date range with program to fetch respective analytics'"
    />
    <div :class="containerClass"></div>
    <div class="page-section border-bottom-2">
      <div :class="containerClass">
        <div class="mt-3">
          <div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5>Filter by Date(s)</h5>
                </div>

                <div>
                  <date-picker
                    v-model="filters.dateRange"
                    format="MMMM DD, YYYY"
                    valueType="YYYY-MM-DD"
                    style="width: 100%"
                    id="date"
                    lang="en"
                    placeholder="Filter by Start Date - End Date Range"
                    range
                    class="w-100 mb-3"
                    :input-attr="{ required: 'true' }"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <h5>Filter by Program</h5>
                </div>
                <div>
                  <v-select
                    id="programs"
                    class="form-control v-select-custom"
                    label="title"
                    v-model="filters.program"
                    :reduce="item => item.id"
                    placeholder="All Programs"
                    :options="allPrograms"
                  >
                    <template #search="{ attributes, events }">
                      <input class="vs__search" :required="!filters.program" v-bind="attributes" v-on="events" />
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-flex align-items-center">
                        <fmv-avatar :title="true" title-class="bg-transparent" rounded no-link slot="aside" size="xs">
                          <b-img :src="option.image" class="img-fluid" width="20" alt="Logo" v-if="option.image" />
                          <md-icon v-else>local_library</md-icon>
                        </fmv-avatar>
                        <span>{{ option.title }}</span>
                      </div>
                    </template>
                  </v-select>
                  <b-form-invalid-feedback :state="isProgramEmpty ? false : null"
                    >This field is required.</b-form-invalid-feedback
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <page-separator>
          <b-link v-b-toggle="'registeration-over-time-section'" class="accordion__toggle p-0">
            <span class="flex">Pre-Registrations Over Time</span>
            <md-icon class="accordion__toggle-icon">
              {{ registerOverTimeVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </md-icon>
          </b-link>
        </page-separator>
        <b-collapse
          id="registeration-over-time-section"
          accordion="registerOverTimeAccordionId"
          :visible="true"
          class="accordion__menu"
          @hide="registerOverTimeVisible = false"
          @show="registerOverTimeVisible = true"
        >
          <div class="card border-left-0 mt-2">
            <div class="card-body">
              <div class="mb-1">
                <div class="flex">
                  <div class="row">
                    <div class="col-lg-auto d-flex align-items-center">
                      <h5 class="card-title fw800" style="font-weight: bold;">Pre-Registrations Over Time</h5>
                    </div>
                    <div class="col-lg d-flex mb-2 flex-wrap justify-content-end align-items-center">
                      <b-btn
                        :hidden="isMobileScreen"
                        variant="primary"
                        :disabled="isPreRegistrationOverTimeRosterLoading"
                        @click.prevent="fetchPreRegistrationOverTimeRoster"
                        :style="`margin-top:${isMobileScreen ? '10px' : '0'}`"
                        class="btn-normal mb-2"
                      >
                        Export to Excel
                        <i v-if="isPreRegistrationOverTimeRosterLoading" class="fas fa-circle-notch fa-spin ml-1"></i>
                        <span v-else class="material-icons icon-16pt ml-1">file_download</span>
                      </b-btn>
                    </div>
                  </div>
                  <p class="text-70">
                    View and export the total pre-registrations in selected program. Use the date filter above to narrow
                    down your selection based on pre-registration date.
                  </p>
                  <div v-if="isMobileScreen" class="timeframe-select">
                    <v-select
                      id="time-frame"
                      class="form-control v-select-custom w-65 "
                      label="label"
                      v-model="timeFrame"
                      :reduce="item => item.value"
                      placeholder="Select Time Frame"
                      :options="timeFrameOptions"
                      :clearable="false"
                    >
                      <template #search="{ attributes, events }">
                        <input class="vs__search" :required="!timeFrame" v-bind="attributes" v-on="events" />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex align-items-center">
                          <span>{{ option.label }}</span>
                        </div>
                      </template>
                    </v-select>
                    <v-select
                      id="reg-status"
                      class="form-control v-select-custom w-65 mt-2"
                      label="label"
                      v-model="preEnrollStatus"
                      :reduce="item => item.value"
                      placeholder="Select enrollment status"
                      :options="preEnrollStatusOptions"
                    >
                      <template #search="{ attributes, events }">
                        <input class="vs__search" v-bind="attributes" v-on="events" />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex align-items-center">
                          <span>{{ option.label }}</span>
                        </div>
                      </template>
                    </v-select>
                    <b-btn
                      variant="primary"
                      :disabled="isPreRegistrationOverTimeRosterLoading"
                      @click.prevent="fetchPreRegistrationOverTimeRoster"
                      style="width: 100%"
                      :style="`margin-top:${isMobileScreen ? '10px' : '0'}`"
                      class="btn-normal mb-2"
                    >
                      Export to Excel
                      <i v-if="isPreRegistrationOverTimeRosterLoading" class="fas fa-circle-notch fa-spin ml-1"></i
                      ><span v-else class="material-icons icon-16pt ml-1">file_download</span>
                    </b-btn>
                  </div>

                  <div v-else>
                    <div class="d-flex mb-2" style="justify-content: space-between;">
                      <div class="d-flex flex-wrap">
                        <v-select
                          id="time-frame"
                          class="form-control v-select-custom w-65"
                          label="label"
                          v-model="timeFrame"
                          :reduce="item => item.value"
                          placeholder="Select Time Frame"
                          :options="timeFrameOptions"
                          :clearable="false"
                          :style="`width:120px`"
                        >
                          <template #search="{ attributes, events }">
                            <input class="vs__search" :required="!timeFrame" v-bind="attributes" v-on="events" />
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-flex align-items-center">
                              <span>{{ option.label }}</span>
                            </div>
                          </template>
                        </v-select>
                        <v-select
                          id="reg-status"
                          class="form-control v-select-custom w-65 ml-2"
                          label="label"
                          v-model="preEnrollStatus"
                          :reduce="item => item.value"
                          placeholder="Select enrollment status"
                          :options="preEnrollStatusOptions"
                          :style="`width:210px`"
                        >
                          <template #search="{ attributes, events }">
                            <input class="vs__search" v-bind="attributes" v-on="events" />
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-flex align-items-center">
                              <span>{{ option.label }}</span>
                            </div>
                          </template>
                        </v-select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="chart-container mt-4" style="position: relative; ">
                        <div v-if="isChartLoading">
                          <div class="text-center mt-5 mb-4">
                            <b-spinner
                              class="align-middle mr-2"
                              :style="{ color: getLoggedInUser.linked_entity.primary_color }"
                            ></b-spinner>

                            <strong>Loading...</strong>
                          </div>
                        </div>
                        <canvas v-else id="registration-graph" class="chart-container"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
        <page-separator>
          <b-link v-b-toggle="'registeration-roster-section'" class="accordion__toggle p-0">
            <span class="flex">Program Roster</span>
            <md-icon class="accordion__toggle-icon">
              {{ registerRosterVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </md-icon>
          </b-link>
        </page-separator>
        <b-collapse
          id="registeration-roster-section"
          accordion="registrationRosterAccordionId"
          :visible="false"
          class="accordion__menu"
          @hide="registerRosterVisible = false"
          @show="registerRosterVisible = true"
        >
          <div class="card border-left-0 mt-2">
            <div class="card-body">
              <div class="d-flex mb-1">
                <div class="flex">
                  <div class="d-flex align-items-center mb-3">
                    <h5 class="card-title fw800" style="font-weight: bold;">Export Program Roster</h5>
                  </div>
                  <p class="text-70 mb-2">
                    View and export the list of students pre-enrolled in selected program. Use the date filter above to
                    narrow down your selection based on Pre-Registration Date.
                  </p>
                  <div class="d-flex justify-content-end mt-3">
                    <b-btn
                      variant="primary"
                      :disabled="isExportLoading"
                      @click.prevent="fetchPreRegistrationRoster"
                      style="width: 200px"
                      class="btn-normal"
                    >
                      Export Roster <i v-if="isExportLoading" class="fas fa-circle-notch fa-spin ml-1"></i
                      ><span v-else class="material-icons icon-16pt ml-1">file_download</span>
                    </b-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div>
      <!-- Your modal trigger button goes here -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { get } from 'lodash';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import vSelect from 'vue-select';
import Page from '@/components/Page.vue';
import { formatToAPIDate } from '../../../common/utils';
import PageSeparator from '@/components/Ui/PageSeparator.vue';
import { FmvAvatar } from 'fmv-avatar';
import { Chart } from 'chart.js';
import PageHeader from '@/components/Ui/PageHeader.vue';

export default {
  components: { DatePicker, vSelect, PageHeader, PageSeparator, FmvAvatar },
  extends: Page,

  data() {
    return {
      title: 'Pre-Registration Reporting',
      areProgramsLoading: false,
      isExportLoading: false,
      isLoading: false,
      isProgramEmpty: false,
      registerRosterVisible: false,
      registerOverTimeVisible: true,
      connection: null,
      filters: {
        dateRange: [],
        program: null,
      },
      allPrograms: [],
      fileUrl: null,
      timeFrame: 'weekly',
      timeFrameOptions: [
        { value: 'weekly', label: 'Weekly' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'yearly', label: 'Yearly' },
      ],
      preEnrollStatus: 'approved',
      preEnrollStatusOptions: [
        { value: 'approved', label: 'Approved' },
        { value: 'disapproved', label: 'Disapproved' },
        { value: 'pending', label: 'Pending' },
        { value: 'registered', label: 'Registered' },
      ],
      isPreRegistrationOverTimeRosterLoading: false,
      chartData: {
        type: 'bar',
        data: {},
        options: this.chartOptions,
      },
      chartInstance: null,
      isChartLoading: false,
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser', 'getAuthToken']),
    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Dashboard', active: true },
      ];
    },
    isMobileScreen() {
      return this.windowWidth <= 420;
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        indexAxis: 'x',
        plugins: {
          legend: {
            position: 'top',
          },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      };
    },
  },

  methods: {
    ...mapActions('program', ['getAllPrograms', 'getRegistrationRoster']),
    ...mapActions('preEnrollForm', [
      'getPreEnrollmentOverTimeGraphData',
      'getPreEnrollmentOverTimeRoster',
      'getPreEnrollmentStdRoster',
    ]),
    ...mapActions('fileDownload', ['downloadFile']),
    get,
    resetFile() {
      this.fileUrl = null;
    },
    async fetchPrograms() {
      this.areProgramsLoading = true;

      const response = await this.getAllPrograms();
      this.allPrograms = response.data;

      this.areProgramsLoading = false;
    },
    async downloadCSV(url) {
      try {
        await this.downloadFile({
          fileUrl: url,
        });
        const h = this.$createElement;
        this.makeToast({
          variant: 'success',
          msg: h('span', [h('i', { class: 'fas fa-download mr-2' }), 'File Downloaded']),
          toaster: 'b-toaster-bottom-left',
        });
      } catch (error) {
        //
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
    },
    async fetchPreRegistrationRoster() {
      if (!this.filters.program) {
        this.isProgramEmpty = true;
        this.makeToast({ variant: 'danger', msg: 'Please select specific program' });
        return;
      }
      this.isProgramEmpty = false;
      this.isExportLoading = true;
      const response = await this.getPreEnrollmentStdRoster({
        prog_id: this.filters.program,
        date_from: this.filters.dateRange[0],
        date_to: this.filters.dateRange[1],
      });
      this.downloadCSV(response.data.url);
      this.isExportLoading = false;
    },

    async fetchPreRegistrationOverTimeRoster() {
      this.isPreRegistrationOverTimeRosterLoading = true;
      const response = await this.getPreEnrollmentOverTimeRoster({
        prog_id: this.filters.program ? this.filters.program : null,
        date_from: this.filters.dateRange[0] ? this.filters.dateRange[0] : null,
        date_to: this.filters.dateRange[1] ? this.filters.dateRange[1] : null,
        time_frame: this.timeFrame,
        pre_enroll_status: this.preEnrollStatus || '',
      });
      this.downloadCSV(response.data.url);
      this.isPreRegistrationOverTimeRosterLoading = false;
    },
    async fetchPreRegistrationGraphData() {
      const response = await this.getPreEnrollmentOverTimeGraphData({
        prog_id: this.filters.program ? this.filters.program : null,
        date_from: this.filters.dateRange[0] ? this.filters.dateRange[0] : null,
        date_to: this.filters.dateRange[1] ? this.filters.dateRange[1] : null,
        time_frame: this.timeFrame,
        pre_enroll_status: this.preEnrollStatus || '',
      });
      return response.data;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    getDateRange(timeframeData) {
      if (timeframeData.date_from && timeframeData.date_to) {
        return `( ${timeframeData.date_from} - ${timeframeData.date_to} )`;
      }
      return '';
    },
    async fetchChartData() {
      this.isChartLoading = true;
      const timeframeData = await this.fetchPreRegistrationGraphData();
      const program = this.filters.program
        ? this.allPrograms.filter(item => item.id === this.filters.program)[0].title
        : null;
      this.chartData = {
        type: 'bar',
        data: {
          labels: timeframeData.labels,
          datasets: [
            {
              label: !program ? 'All Programs' : `${program}`,
              data: timeframeData.datasets,
              backgroundColor: this.getLoggedInUser.linked_entity.primary_color,
            },
          ],
        },
        options: {
          legend: {
            labels: {
              fontColor: this.getLoggedInUser.linked_entity.secondary_color,
            },
          },
          maintainAspectRatio: false,
          responsive: true,
          lineTension: 1,
          layout: { padding: { right: 25 } },
          scales: {
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: 'Number Of Students',
                },
                ticks: {
                  fontColor: this.getLoggedInUser.linked_entity.secondary_color,
                  beginAtZero: true,
                  padding: this.isMobileScreen ? 8 : 15,
                },
              },
            ],
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: 'Date Applied ' + this.getDateRange(timeframeData),
                  fontSize: 14,
                },
                ticks: {
                  fontColor: this.getLoggedInUser.linked_entity.secondary_color,
                  padding: this.isMobileScreen ? 8 : 15,
                },
              },
            ],
          },
        },
      };
      this.isChartLoading = false;
    },
    fetchAndUpdateChartData() {
      this.fetchChartData()
        .then(() => {
          const ctx = document.getElementById('registration-graph');
          if (this.chartInstance) {
            this.chartInstance.destroy();
          }

          this.chartInstance = new Chart(ctx, this.chartData);
        })
        .catch();
    },
  },
  watch: {
    'filters.program': 'fetchAndUpdateChartData',
    'filters.dateRange': 'fetchAndUpdateChartData',
    timeFrame: 'fetchAndUpdateChartData',
    preEnrollStatus: 'fetchAndUpdateChartData',
  },
  async mounted() {
    this.fetchPrograms();
    this.filters.dateRange = [formatToAPIDate(moment().startOf('month')), formatToAPIDate(moment().endOf('month'))];
    this.fetchAndUpdateChartData();
  },
};
</script>
<style scoped>
.chart-container {
  width: 100%;
  height: 40vh;
}
@media only screen and (max-width: 700px) {
  .chart-container {
    width: 100%;
    height: 40vh;
  }
}
@media only screen and (max-width: 425px) {
  .chart-container {
    width: 250px;
    height: 250px;
  }
}
</style>
